import {
  type CSSProperties,
  type ChangeEventHandler,
  type FocusEventHandler,
  type FormEventHandler,
  type WheelEventHandler,
} from 'react';

import { pad } from '~/shared/components/DateRangePopup/helpers';
import { Input } from '~/shared/components/Input';

const inputStyles: CSSProperties = {
  border: '1px solid #DBDDE4',
  width: '40px',
  height: '36px',
  padding: '7px',
  fontSize: '14px',
  textAlign: 'center',
};

interface TimeNumberInputProps {
  value: string;
  onChange: (value: string) => void;
  min: number;
  max: number;
  placeholder: string;
}

export default function TimeNumberInput({
  value,
  onChange,
  min,
  max,
  placeholder,
}: TimeNumberInputProps) {
  const onBlur: FocusEventHandler<HTMLInputElement> = (e) => {
    e.currentTarget.value = pad(e.currentTarget.value);
    onChange(e.currentTarget.value);
  };

  const onWheel: WheelEventHandler<HTMLInputElement> = (e) => {
    e.currentTarget.blur();
  };

  const onValueChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    onChange(e.target.value);
  };

  const onInput: FormEventHandler<HTMLInputElement> = (e) => {
    if (e.currentTarget.value.length > 2) {
      e.currentTarget.value = e.currentTarget.value.slice(0, 2);
    }
  };

  return (
    <Input
      style={inputStyles}
      placeholder={placeholder}
      value={value}
      onInput={onInput}
      onChange={onValueChange}
      onBlur={onBlur}
      onWheel={onWheel}
      type="number"
      maxLength={2}
      tabIndex={-1}
      min={min}
      max={max}
    />
  );
}
